<template>
  <!--
    gs-alert-dialog has no slot for the Mux checkbox, so this uses the same
    composition it renders (gs-modal size sm + alert-dialog copy/actions), as SourceRow does.
  -->
  <gs-modal
    class="gs-alert-dialog"
    :value="value"
    title="Delete video?"
    size="sm"
    :close-on-backdrop="false"
    @input="$emit('input', $event)"
  >
    <p class="gs-alert-dialog__copy">{{ copy }}</p>
    <label v-if="isMux" class="gs-delete-video__mux">
      <input v-model="deleteFromMux" data-field="delete-from-mux" type="checkbox" />
      <span class="gs-delete-video__mux-text">
        <span class="gs-delete-video__mux-label">Also delete from my Mux account</span>
        <span class="gs-delete-video__mux-help">Permanently removes the file from Mux. Leave this off to keep it for other players.</span>
      </span>
    </label>
    <div class="gs-alert-dialog__actions">
      <gs-button variant="secondary" data-action="cancel-delete" @click="$emit('input', false)">Cancel</gs-button>
      <gs-button variant="danger" data-action="confirm-delete" @click="confirm()">Delete</gs-button>
    </div>
  </gs-modal>
</template>

<script>
import { isMuxVideo } from '@/utils/muxSource';

export default {
  name: 'DeleteVideoDialog',
  props: {
    value: { type: Boolean, default: false },
    video: { type: Object, default: null },
  },
  data() {
    return { deleteFromMux: false };
  },
  computed: {
    isMux() {
      return isMuxVideo(this.video);
    },
    copy() {
      return this.video ? `"${this.video.name}" will be removed along with its analytics. This cannot be undone.` : '';
    },
  },
  watch: {
    value(open) {
      if (open) this.deleteFromMux = false;
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm', { deleteFromMux: this.isMux && this.deleteFromMux });
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.gs-delete-video__mux { display: flex; gap: 10px; align-items: flex-start; margin: 4px 0 16px; padding: 12px 14px; background: var(--gs-surface-subtle); border: 1px solid var(--gs-border); border-radius: var(--gs-radius-md); cursor: pointer; }
.gs-delete-video__mux input { margin-top: 3px; }
.gs-delete-video__mux-text { display: flex; flex-direction: column; gap: 2px; }
.gs-delete-video__mux-label { color: var(--gs-foreground); font-size: 14px; font-weight: 600; }
.gs-delete-video__mux-help { color: var(--gs-muted-foreground); font-size: 13px; line-height: 1.5; }
</style>
